import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import extractText from 'flarum/common/utils/extractText';
import CaptionModal from './components/CaptionModal';
const BUTTON_CLASS = 'ChampisCaptions-button';

/**
 * A button under each photo of a post its viewer may caption (the
 * post's `champisCaptionableImages`, by uuid - see CaptionPermission):
 * "Ajouter une légende", or "Modifier la légende" when it has one, opening
 * CaptionModal.
 *
 * Put straight into the post's body - server-rendered HTML (contentHtml),
 * not Mithril's: into each photo's <figure> (ImageCaptionFix's, around
 * fof/upload's <a><img data-id="{uuid}"></a>, its <figcaption> after).
 * Again after each redraw: the same body keeps its buttons, a new one (the
 * post edited, or fetched again with its new caption) gets them back.
 */
function addButtons(body, post) {
  const uuids = post.attribute('champisCaptionableImages') || [];
  body.querySelectorAll('.FoFUpload--Upl-Image-Preview-Figure').forEach(figure => {
    const image = figure.querySelector('img[data-id]');
    const uuid = image?.dataset.id;
    const existing = figure.querySelector(`.${BUTTON_CLASS}`);
    if (!image || !uuid || !uuids.includes(uuid)) {
      existing?.remove();
      return;
    }
    const caption = figure.querySelector('figcaption')?.textContent?.trim() || '';
    const button = existing || figure.appendChild(document.createElement('button'));
    button.type = 'button';
    button.className = `Button Button--link ${BUTTON_CLASS}`;
    const icon = document.createElement('i');
    icon.className = 'icon fas fa-pen Button-icon';
    icon.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span');
    label.className = 'Button-label';
    label.textContent = extractText(app.translator.trans(`champis-captions.forum.${caption ? 'edit_button' : 'add_button'}`));
    button.replaceChildren(icon, label);
    button.onclick = e => {
      // Not the photo's own click: the lightbox (champis-forum).
      e.preventDefault();
      e.stopPropagation();
      app.modal.show(CaptionModal, {
        post,
        uuid,
        caption,
        imageUrl: image.currentSrc || image.src,
        url: figure.querySelector('a.FoFUpload--Upl-Image-Preview-Link')?.href || null
      });
    };
  });
}
export default function addCaptionButtons() {
  extend('flarum/forum/components/CommentPost', ['oncreate', 'onupdate'], function (_value, vnode) {
    // While editing, the body is the composer's preview.
    if (this.isEditing()) return;
    const {
      dom,
      attrs
    } = vnode;
    const body = dom.querySelector('.Post-body');
    if (body) addButtons(body, attrs.post);
  });
}